export const API = process.env.REACT_APP_API_URL || "http://localhost:5001";
export const TOKEN = "admin_secret_token_kepwix_2025";
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || "admin@kepwix.com";
export const ADMIN_PASS = process.env.REACT_APP_ADMIN_PASS || "Admin@123";

export const headers = {
  "Content-Type": "application/json",
  "x-admin-token": TOKEN,
};

export const apiFetch = (path, options = {}) =>
  fetch(`${API}${path}`, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });
